<template>
    <row :reversed="reverse" align="center" class="xs:flex-wrap-reverse xs:flex-wrap sm:flex-no-wrap md:flex-no-wrap"
         justify="center">
        <column shrink sm="full" xl="1/3" xs="full">
            <row align="stretch" class="text-center" justify="center" no-wrap>
                <column :class="small ? '' : reverse ? '' : 'mx-4'" justify="center">
                    <card :height="small ? '155' : reverse ? '140' : '182'"
                          :key="index"
                          :width="small ? '155' : reverse ? '140' : '182'"
                          class="mb-8"
                          round
                          v-for="(item, index) in items.left"
                    >
                        <div class="flex items-center h-full">
                            <div class="text-secondary tracking-normal leading-tight">
                                {{ item }}
                            </div>
                        </div>
                    </card>
                </column>
                <column>
                    <card :height="small ? '155' : reverse ? '140' : '182'"
                          :key="index"
                          :width="small ? '155' : reverse ? '140' : '182'"
                          class="mb-8"
                          round
                          v-for="(item, index) in items.right"
                    >
                        <div class="flex items-center h-full">
                            <div class="text-secondary tracking-normal leading-tight">
                                {{ item }}
                            </div>
                        </div>
                    </card>
                </column>
            </row>
        </column>
        <column align="center" class="lg:py-12" justify="center" sm="full" v-if="innerWidth > 1270 || innerWidth <= 640" xl="1/3"
                xs="full">
            <object
                :data="require('@/assets/images/components/fitt_framework.svg')"
                @load="initAnimations()"
                class="xs:hidden fitt-framework-svg"
                id="fitt_framework_svg"
                style="width: 500px; max-width: 100%;"
                type="image/svg+xml"
                v-if="innerWidth > 1270"
            ></object>
            <object
                :data="require('@/assets/images/components/fitt_framework.svg')"
                @load="initAnimations()"
                class="sm:hidden"
                id="fitt_framework_svg_small"
                style="max-width: 100%; width: 400px;"
                type="image/svg+xml"
            ></object>
        </column>
        <!--        sm:px-12-->
        <column align="center" class="xs:items-center" shrink sm="full" xl="1/3" xs="full">
            <div>
                <divider color="primary" width="56"></divider>
                <div
                    class="xs:text-3xl sm:text-5xl poppins-bold tracking-normal leading-higher text-secondary xs:mt-4 sm:mt-6">
                    fitt Framework
                </div>
                <div class="uppercase text-primary xs:my-6 sm:mb-8 sm:mt-10 poppins-bold tracking-widest">Driving
                    Elements
                </div>
                <ul class="text-left text-secondary list-none list-inside tracking-normal leading-tight xs:text-2xl sm:text-xl xs:my-2">
                    <li>Fully digital (virtual)</li>
                    <li>Multi-method</li>
                    <li>Journeyed interface</li>
                    <li>IO Psychologist Expert Interpretation</li>
                </ul>
                <div class="text-primary uppercase xs:my-6 sm:my-10 poppins-bold tracking-widest">Multi - Dimensional
                </div>
                <div>
                    <div :class="index > 0 && index < lookItems.length - 1 ? 'xs:my-5 sm:my-10' : ''"
                         :key="index"
                         class="flex flex-no-wrap"
                         v-for="(look, index) in lookItems"
                    >
                        <column shrink>
                            <card class="mr-6" height="71" no-padding round width="71">
                                <div class="h-full flex items-center justify-center">
                                    <icon :class="look.class || []" :icon="look.icon" color="primary"></icon>
                                </div>
                            </card>
                        </column>
                        <column justify="center" style="min-height: 50px;">
                            <div class="uppercase text-secondary poppins-bold tracking-wide leading-tight mb-1">
                                {{ look.title }}
                            </div>
                            <div class="text-secondary tracking-normal leading-tight">{{ look.subtitle }}</div>
                        </column>
                    </div>
                </div>
            </div>
        </column>
    </row>
</template>

<script>
    import Helpers from "../../mixins/Helpers";
    import anime from "animejs";

    export default {
        name: "FittFramework",
        mixins: [Helpers],
        components: {
            divider: () => import('@/components/Divider.vue'),
            row: () => import('@/components/display/Row.vue'),
            column: () => import('@/components/display/Col.vue'),
            card: () => import('@/components/Card.vue'),
            icon: () => import('@/components/display/Icon.vue'),
        },
        computed: {
            reverse() {
                return this.innerWidth <= 640;
            },
            small() {
                return this.innerWidth > 640 && this.innerWidth <= 860;
            }
        },
        data: () => ({
            items: {
                left: [
                    'Work Personality, Engagement Drivers, Well-being Instruments',
                    'Animated Situational Judgement Testing'
                ],
                right: [
                    'AI Supported Video Interviewing',
                    'Custom Simulations & Real-time exercises',
                    'Complexity solvers & reasoning Testing'
                ]
            },
            lookItems: [
                {title: 'Back Looking', subtitle: 'Experience and exposures', icon: 'refresh'},
                {title: 'In Looking', subtitle: 'Foundational', icon: 'sync'},
                {
                    title: 'Forward Looking',
                    subtitle: 'Mobility & transition potential',
                    icon: 'refresh',
                    class: ['transform rotate-180']
                }
            ],
            innerWidth: 0
        }),
        methods: {
            setInnerWidth() {
                this.innerWidth = window.innerWidth;
            },
            getElement(item, id) {
                return item.contentDocument.querySelector(id);
            },
            initAnimations() {
                let main = this.$el.querySelector('#fitt_framework_svg') || this.$el.querySelector('#fitt_framework_svg_small'),
                    star_1 = this.getElement(main, '#Path_545'),
                    star_2 = this.getElement(main, '#Path_544'),
                    star_3 = this.getElement(main, '#Path_541'),
                    star_4 = this.getElement(main, '#Path_542'),
                    star_5 = this.getElement(main, '#Path_543'),
                    play = this.getElement(main, '#Path_526');
                this.animateStars([star_1, star_2, star_3, star_4, star_5], 1.01, 2000);
                this.animatePlayButton(play, 180, 180, 1.3, 2000, 2000);
            },
            animateStars(stars, scale, duration) {
                anime({
                    targets: stars,
                    keyframes: [
                        {scale: scale},
                        {scale: 1}
                    ],
                    duration: duration,
                    direction: 'alternate',
                    delay: anime.stagger(200),
                    loop: true
                });
            },
            animatePlayButton(target, rotate, rotateY, scale, duration, delay) {
                anime.set(target, {transformOrigin: '40% 50%', transformBox: 'fill-box'});
                anime({
                    targets: target,
                    keyframes: [
                        {rotate: rotate},
                        {rotateY: rotateY},
                        {scale: scale},
                        {scale: 1}
                    ],
                    duration: duration,
                    easing: 'easeInOutQuad',
                    delay: delay,
                    loop: true
                });
            }
        },
        mounted() {
            window.addEventListener('resize', this.debounce(this.setInnerWidth, 500));
            this.setInnerWidth();
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.setInnerWidth);
        }
    }
</script>

<style scoped>
    li::before {
        content: "\2022"; /* Add content: \2022 is the CSS Code/unicode for a bullet */
        color: #0174EA; /* Change the color */
        font-weight: bold; /* If you want it to be bold */
        display: inline-block; /* Needed to add space between the bullet and the text */
        width: 1em; /* Also needed for space (tweak if needed) */
        margin-left: -1em; /* Also needed for space (tweak if needed) */
    }

    li {
        padding-left: 1em;
    }

    @media only screen and (max-width: 1024px) {
        .fitt-framework-svg {
            display: none;
        }
    }

    /*.aspect-ratio-box::before {*/
    /*    content: "";*/
    /*    padding-bottom: 100%;*/
    /*}*/
</style>